export default __webpack_public_path__ + "static/media/08.950b2dc7.jpg";